import _ from 'lodash'
import { DateTime } from 'luxon'

export const icon = 'flag'
export const humanName = {
  singular: 'Missão',
  plural: 'Missões'
}
export const status = [
  { slug: 'open', name: 'Ativa', variant: 'light-success' },
  {
    slug: 'soon',
    name: 'Abre em breve',
    variant: 'light-warning'
  },
  { slug: 'closed', name: 'Encerrada', variant: 'light-danger' }
]
export const toleranceMinutes = 3
export const getStatus = (props = {}) => {
  const { start_at, end_at } = props
  const now = DateTime.local()
  const startAt = DateTime.fromISO(start_at)
  const endAt = DateTime.fromISO(end_at)

  let slug = 'open'
  if (now < startAt) slug = 'soon'
  else if (endAt && endAt.isValid && now >= endAt) slug = 'closed'

  return _.find(status, { slug })
}
export const submissionStatus = [
  { slug: 'pending', name: 'Aguardando aprovação', variant: 'warning' },
  { slug: 'approved', name: 'Aprovado', variant: 'success' },
  { slug: 'refused', name: 'Recusado', variant: 'danger' },
  { slug: 'awaiting_correction', name: 'Aguardando correção', variant: 'dark' }
]
export const getSubmissionStatus = slug => _.find(submissionStatus, { slug })
export const capacityStatus = [
  { slug: 'awaiting_minimum', name: 'Aguardando mínimo', variant: 'warning' },
  { slug: 'active', name: 'Ativo', variant: 'success' },
  { slug: 'full', name: 'Lotado', variant: 'danger' },
]
export const getCapacityStatus = slug => _.find(capacityStatus, { slug })
export const getConfig = props => {
  const { digitalProductId } = props
  const basePath = '/missoes'
  const apiBasePath = `/user/digital_products/${digitalProductId}/missions`
  const getBreadcrumbs = (breadcrumbs = []) => [
    {
      href: basePath,
      name: humanName.plural
    },
    ...breadcrumbs
  ]
  const config = {
    basePath,
    apiBasePath,
    icon,
    humanName,
    pagination: {
      per_page: 999
    },
    sort: {
      field: 'position',
      order: 'asc'
    },
    getBreadcrumbs,
    status,
    getStatus,
    submissionStatus,
    getSubmissionStatus,
    toleranceMinutes,
    capacityStatus,
    getCapacityStatus
  }

  return config
}
